import axios from "@galaxy/modules/Core/resources/js/axiosBuilder";
import getDatabaseColors from "../../../../../Canvas/resources/components/canvas/blocks/utils/text/admin/getDatabaseColors";

common.View.create('crud::form.inputs.Colorpicker', {

    onDOMLoad()
    {
        this.initColorPicker();
    },

    async initColorPicker() {
        // Simple example, see optional options for more configuration.
        const pickr = Pickr.create({
            el: this.element.find('input[type="text"]').get(0),
            theme: 'classic', // or 'monolith', or 'nano'

            useAsButton: false,

            default: this.element.find('input[type="text"]').data('default-color'),

            swatches: await this.initDatabaseColors(),

            lockOpacity: true,

            components: {

                // Main components
                opacity: false,
                hue: true,

                // Input / output Options
                interaction: {
                    hex: true,
                    input: true,
                    clear: true,
                    save: true
                }
            },

            strings: {
                save: 'Opslaan',  // Default for save button
                clear: 'Legen', // Default for clear button
                cancel: 'Annuleren' // Default for cancel button
            },

        }).on('save', (color, instance) => {
            // Update hidden field.
            this.element.find('input[type="hidden"]').val(color ? color.toHEXA().toString() : '');

            // Hide picker on save
            pickr.hide();
        }).on('clear', (color, instance) => {
            // Set color null on clear
            this.element.find('input[type="hidden"]').val('');

            // Hide picker on clear
            pickr.hide();
        });
    },

    async initDatabaseColors()
    {
        // Grab database colors
        let databaseColors = (await getDatabaseColors()).data;

        // Initialize empty array
        let colorsToColorPicker = [];

        // Add colors from database to array in CKeditor format
        $.each(databaseColors, function (item, value)
        {
            if (typeof value !== 'string') {
                colorsToColorPicker.push(...Object.values(value));
            } else {
                colorsToColorPicker.push(value);
            }
        });

        // Filter duplicates
        let colors = [...new Set(colorsToColorPicker)];

        // Return colors
        return [
            '#ffffff',
            '#000000',
            ...colors,
        ];
    },

});
